import React, { Component } from "react";
import { Helmet } from "react-helmet";
import MaduraiPandianContent from "../../components/about-us/MaduraiPandianContent";
// import MissionArea from "../components/about-us/MissionArea";
// import SolutionArea from "../components/about-us/SolutionArea";
// import TestimonialArea from "../components/about-us/TestimonialArea";
// import SubscribeArea from "../components/home/SubscribeArea";
import Layout from "../../components/Layout";
import PageHeader from "../../components/service/PageHeader";

export default class AboutJciMaduraiPandian extends Component{
    componentDidMount(){
        console.log("componentDidMount called");
        window.scrollTo(0,0);
    }
    render(){
        return(
            <>
            <Helmet>
                <title>About Jci Madurai Pandian | Madurai Pandian</title>
                {/* <meta name='description' content='AboutUs - Madurai Pandian' /> */}
            </Helmet>
            <Layout>
                <PageHeader bannerTitle="About JCI Madurai Pandian"/>
                <MaduraiPandianContent/>
                {/* <SolutionArea/> */}
                {/* <MissionArea/> */}
                {/* <TestimonialArea/> */}
                {/* <SubscribeArea/> */}
            </Layout>
            </>
        );
    }
}